module.exports = __webpack_public_path__ + "static/media/short-arrow-r.f65a4388.svg";